(function () {
  var currentOnClose = null;

  function ensureModal() {
    if (document.getElementById('pqv-overlay')) return;
    var overlay = document.createElement('div');
    overlay.id = 'pqv-overlay';
    overlay.className = 'pqv-overlay';
    overlay.innerHTML =
      '<div class="pqv-modal" role="dialog" aria-modal="true">' +
        '<button type="button" class="pqv-close" aria-label="Close">&times;</button>' +
        '<div class="pqv-image-wrap"><img id="pqv-img" src="" alt=""></div>' +
        '<div class="pqv-body">' +
          '<h2 class="pqv-title" id="pqv-title"></h2>' +
          '<div class="pqv-price-row" id="pqv-price-row"></div>' +
          '<div class="pqv-tags" id="pqv-tags"></div>' +
          '<p class="pqv-description" id="pqv-description"></p>' +
          '<div class="pqv-actions" id="pqv-actions"></div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });
    overlay.querySelector('.pqv-close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  function close() {
    var overlay = document.getElementById('pqv-overlay');
    if (overlay) {
      overlay.classList.remove('open');
      var actions = overlay.querySelector('#pqv-actions');
      if (actions) actions.innerHTML = '';
    }
    if (typeof currentOnClose === 'function') {
      try { currentOnClose(); } catch (e) {}
    }
    currentOnClose = null;
  }

  function open(data) {
    ensureModal();
    var overlay = document.getElementById('pqv-overlay');

    if (typeof currentOnClose === 'function') {
      try { currentOnClose(); } catch (e) {}
    }
    currentOnClose = data.onClose || null;

    overlay.querySelector('#pqv-img').src = data.image || '';
    overlay.querySelector('#pqv-img').alt = data.title || '';
    overlay.querySelector('#pqv-title').textContent = data.title || '';
    overlay.querySelector('#pqv-description').textContent = data.description || '';
    overlay.querySelector('#pqv-price-row').innerHTML = data.priceHtml || '';
    overlay.querySelector('#pqv-tags').innerHTML = data.tagsHtml || '';

    var actions = overlay.querySelector('#pqv-actions');
    actions.innerHTML = '';
    if (data.controlEl) actions.appendChild(data.controlEl);

    overlay.classList.add('open');
  }

  window.ProductQuickview = { open: open, close: close };
})();
